// extracted by mini-css-extract-plugin
export default {"tour":"GlobalProductTour_tour__Xsbl2"};